<template>
    <div>
        <h2 class="ix-page-title-secondary mt-4">Contenu</h2>
         <div v-if="allowed_overheads == 0" class="alert alert-warning mt-2">
            Les frais généraux sont désactivés : chaque ligne doit être ventilée sur au moins une affaire
            ou un rapport d'intervention (aucune partie ne doit rester en "Frais généraux").
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="ix-table-box mb-3">
                    <table class="ix-table">
                        <thead>
                        <tr>
                            <th style="width: 30px;"></th>
                            <th style="width: 30px;">
                                <span data-toggle="tooltip" data-placement="top" title="Définir comme titre"><i class="far fa-text"></i></span>
                            </th>
                            <th style="width: 150px;">Référence</th>
                            <th>Désignation</th>
                            <th style="width: 120px;">Qté</th>
                            <th class="text-right" style="width: 180px;">P.U. HT</th>
                            <th class="text-center" style="width: 120px;">Remise</th>
                            <th class="text-right" style="width: 180px;">Total H.T.</th>
                            <th class="text-center" style="width: 120px;" v-if="isAutoliquidation != 1">Tva</th>
                            <th style="width: 120px;"></th>
                        </tr>
                        </thead>
                        <draggable v-model="purchases" tag="tbody" handle=".handle-line" v-if="!loading">
                            <tr v-for="(purchase, index) in purchases" is="purchase-form" ref="purchaseFormComponent"
                                v-bind:key="purchase.uniq"
                                :purchase="purchase"
                                :index="index"
                                :discount="discount"
                                :isAutoliquidation="isAutoliquidation"
                                :suggestionsRoute="suggestionsRoute"
                                :expenseId="expenseId"
                                :tva="globalTva"
                                :types="JSON.parse(types)"
                                v-on:purchase-editing-started="checkIfNewRowNeeded($event)"
                                v-on:purchase-deleted="deleteRow($event)"
                                v-on:purchase-manage-associations-started="openAssociationsModal($event)"
                            ></tr>
                        </draggable>
                        <tr v-if="loading">
                            <td colspan="9" class="text-center">
                                <i class="far fa-circle-notch fa-spin"></i>
                            </td>
                        </tr>
                    </table>
                </div>

                <button type="button" class="ix-btn link" @click="addRow(null)"><i class="far fa-plus"></i> Nouvel achat</button>
            </div>
        </div>

        <div class="modal fade" id="associationsModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="associationsModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" v-show="selectedIndexAssociation != null">
                    <div class="modal-header">
                        <h5 class="modal-title" v-if="purchases[selectedIndexAssociation]">{{ purchases[selectedIndexAssociation].designation }}</h5>
                    </div>
                    <div class="modal-body">

                        <h3 class="ix-page-title-secondary">Ventilation</h3>

                       
                        <div class="custom-control custom-switch mt-2 mb-2">
                            <input type="checkbox" class="custom-control-input" id="mode_ventilation" name="mode_ventilation" v-model="interventionVentilation" @change="resetVentilation">
                            <label class="custom-control-label" for="mode_ventilation">Rap. d'intervention</label>
                        </div>


                        <div class="ix-table-box" v-show="!interventionVentilation">
                            <table class="ix-table ix-table-sm align-middle">
                                <thead>
                                    <tr>
                                        <th>Affaires</th>
                                        <th class="text-center">Quantité</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody  v-if="selectedIndexAssociation != null">
                                    <tr v-for="(association, index) in purchases[selectedIndexAssociation].deal_associations" :key="index" class="align-middle">
                                        <td class="align-middle">
                                            <div class="d-flex flex-column">
                                                <span v-html="truncate(association.deal_designation, 50)"></span>

                                                <div class="mb-2" v-if="association.lots && association.lots.length > 0">
                                                    <select
                                                        v-model="association.lot_id"
                                                        :disabled="associate_all_deal_lot_purchases"
                                                        class="form-control form-control-sm w-100"
                                                        @change="addLotToDealAssociation(association, index)"
                                                    >
                                                        <option :value="null">Sélectionner un lot</option>
                                                        <option v-for="lot in association.lots" :key="lot.id" :value="lot.id">
                                                            {{ lot.number }} - {{ lot.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="text-muted small" v-else>Aucun lot disponible</div>
                                            </div>
                                        </td>
                                        <td class="text-center align-middle">
                                            <input
                                                type="number"
                                                :disabled="associate_all_deal_purchases"
                                                v-model="association.quantity"
                                                class="form-control form-control-sm text-center"
                                                step="0.001"
                                                :id="'association' + index"
                                            >
                                        </td>
                                        <td class="text-right align-middle" v-show="!associate_all_deal_purchases">
                                            <button type="button" class="btn btn-sm transparent" @click="deleteAssociation(index)">
                                                <i class="far fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {{ purchases[selectedIndexAssociation].article_id ? 'Stock' : 'Frais généraux' }}
                                        </td>
                                        <td class="text-center">
                                            {{ purchases[selectedIndexAssociation].quantity - total_associations }}
                                        </td>
                                        <td></td>
                                    </tr>
                                </tbody>
                                <tbody>
                                    <tr>
                                        <td colspan="100%">
                                            <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control form-control-sm" id="dealsAutocomplete" type="text" v-model="searchDeal" :disabled="associate_all_deal_purchases">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="ix-table-box" v-show="interventionVentilation">
                             <table class="ix-table ix-table-sm" >
                                <thead>
                                    <tr>
                                        <th>Rapport d'intervention</th>
                                        <th class="text-center">Quantité</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                     <tbody  v-if="selectedIndexAssociation != null">
                                        <tr v-for="(association, index) in purchases[selectedIndexAssociation].intervention_associations" :key="index">
                                            <td>
                                                <span v-html="truncate(association.intervention_designation, 50)"></span>
                                            </td>
                                            <td class="text-center">
                                                <input type="number" :disabled="associate_all_intervention_purchases" v-model="association.quantity" class="form-control form-control-sm text-center" step="0.001" :id="'association' + index">
                                            </td>
                                            <td class="text-right" v-show="!associate_all_intervention_purchases">
                                                <button type="button" class="btn btn-sm transparent" @click="deleteAssociation(index)">
                                                    <i class="far fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {{ purchases[selectedIndexAssociation].article_id ? 'Stock' : 'Frais généraux' }}
                                            </td>
                                            <td class="text-center">
                                                {{ purchases[selectedIndexAssociation].quantity - total_associations }}
                                            </td>
                                            <td></td>
                                        </tr>
                                    </tbody>

                                    <tbody>
                                        <tr>
                                            <td colspan="100%">
                                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control form-control-sm" id="interventionsAutocomplete" type="text" v-model="searchIntervention" :disabled="associate_all_intervention_purchases">
                                            </td>
                                        </tr>
                                    </tbody>
                             </table>
                        </div>

                        <div v-if="selectedIndexAssociation != null && selectedDealAssociation != null && !interventionVentilation">
                            <div class="form-check mt-3">
                                <input class="form-check-input" type="checkbox" value="1" id="associate_all_deal_purchases" v-model="associate_all_deal_purchases" v-on:change="associateAllDealPurchases()">
                                <label class="form-check-label" for="associate_all_deal_purchases">
                                    Ventiler tous les achats sur l'affaire <b>{{ selectedDealAssociation.designation }}</b>?
                                </label>
                            </div>
                            <div class="form-check mt-3" v-if="selectedDealAssociation.lots && selectedDealAssociation.lots.length > 0 && currentLotSelected && currentLotSelected.deal_id == selectedDealAssociation.id && associate_all_deal_purchases">
                                <input class="form-check-input" type="checkbox" value="1" id="associate_all_deal_lot_purchases" v-model="associate_all_deal_lot_purchases" v-on:change="associateAllDealLotPurchases()"></input>
                                <label class="form-check-label" for="associate_all_deal_lot_purchases">
                                    Ventiler tous les achats sur le lot <b>{{ currentLotSelected.number }} - {{ currentLotSelected.name }}</b>?
                                </label>
                            </div>
                        </div>

                        <div v-if="selectedIndexAssociation != null && selectedInterventionAssociation != null && interventionVentilation">
                            <div class="form-check mt-3">
                                <input class="form-check-input" type="checkbox" value="1" id="associate_all_intervention_purchases" v-model="associate_all_intervention_purchases" v-on:change="associateAllInterventionPurchases()">
                                <label class="form-check-label" for="associate_all_intervention_purchases">
                                    Ventiler tous les achats sur le rapport d'intervention <b>{{ selectedInterventionAssociation.designation }}</b>?
                                </label>
                            </div>
                        </div>

                        <div v-if="selectedIndexAssociation != null">
                            <div class="alert alert-danger mt-4" v-if="purchases[selectedIndexAssociation].quantity < total_associations">
                                La somme des quantités associées ne peut pas dépasser {{ purchases[selectedIndexAssociation].quantity  }}
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer" v-if="selectedIndexAssociation != null">
                        <button type="button" class="ix-btn green" @click="validAssociations()" :disabled="purchases[selectedIndexAssociation].quantity < total_associations">Enregistrer</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-4 mt-2" v-if="!loading">
            <div class="col-sm-12 col-md-12 col-lg-4 offset-lg-8">
                <div class="ix-trade-totals">
                    <table class="ix-table ix-table-transparent">
                        <tbody>
                        <tr>
                            <td>Total HT</td>
                            <td class="text-right">{{ currency(total_ht) }}</td>
                        </tr>
                        <tr>
                            <td>
                                Remise globale
                                <div class="input-group input-group-sm" style="width: 120px;">
                                    <input type="number" class="form-control text-center" name="discount" v-model="discount" required min="0">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                    </div>
                                </div>
                            </td>
                            <td class="text-right">- {{ currency(total_discount) }}</td>
                        </tr>
                        <tr>
                            <td class="ix-text-bold">
                                Net commercial
                            </td>
                            <td class="text-right">
                                <span class="ix-text-bold ix-text-xlarge">{{ currency(total_after_discount) }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Total TVA
                                <div>
                                    <span class="ix-text-bold">Autoliquidation</span>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="is_autoliquidation" id="is_autoliquidation_false" value="0" v-model="isAutoliquidation">
                                        <label class="form-check-label" for="is_autoliquidation_false">Non</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" name="is_autoliquidation" id="is_autoliquidation_true" value="1" v-model="isAutoliquidation">
                                        <label class="form-check-label" for="is_autoliquidation_true">Oui</label>
                                    </div>
                                </div>
                            </td>
                            <td class="text-right">{{ currency(total_vat) }}</td>
                        </tr>
                        <tr>
                            <td>Total TTC</td>
                            <td class="text-right">{{ currency(total_ttc) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PurchaseForm from "./PurchaseForm";
    import draggable from 'vuedraggable';

    export default {
        name: 'purchase-table-form',
        props: ['suggestionsRoute', 'oldPurchases', 'oldAutoliquidation', 'oldDiscount', 'expenseId', 'dealsRoute', 'interventionsRoute' ,'types', 'tvaGlobal', 'allowedOverheads'],
        components : {
            PurchaseForm,
            draggable
        },
        data() {
            return {
                loading: true,
                discount: 0,
                isAutoliquidation: 0,
                purchases: [],
                selectedIndexAssociation: null,
                selectedDealAssociation: null,
                searchDeal: null,
                associate_all_deal_purchases: false,
                globalTva: this.tvaGlobal,
                interventionVentilation: false,
                associate_all_intervention_purchases: false,
                selectedInterventionAssociation: null,
                searchIntervention: null,
                associate_all_deal_lot_purchases: false,
                currentLotSelected: null,
                allowed_overheads : this.allowedOverheads ? this.allowedOverheads : 1,
                isVentilationValid: true,
            };
        },
        computed: {
            total_ht: function() {
                var sum = 0;
                this.purchases.forEach(purchase => sum += parseFloat(purchase.total_ht));
                return sum;
            },
            total_discount: function() {
                var sum = 0;
                this.purchases.forEach(purchase => sum += parseFloat(purchase.total_discount));
                return sum;
            },
            total_after_discount: function() {
                var sum = 0;
                this.purchases.forEach(purchase => sum += parseFloat(purchase.total_after_discount));
                return sum;
            },
            total_vat: function() {
                var sum = 0;
                this.purchases.forEach(purchase => sum += parseFloat(purchase.total_vat));
                return sum;
            },
            total_ttc: function() {
                var sum = 0;
                this.purchases.forEach(purchase => sum += parseFloat(purchase.total_ttc));
                return sum;
            },
            total_associations: function() {
                var sum = 0;

                if (this.selectedIndexAssociation != null && !this.interventionVentilation) {
                    this.purchases[this.selectedIndexAssociation].deal_associations.forEach(association => {
                        if (association.quantity != '' && association.quantity != null) {
                            sum += parseFloat(association.quantity)
                        }
                    })
                }

                if (this.selectedIndexAssociation != null && this.interventionVentilation) {
                    this.purchases[this.selectedIndexAssociation].intervention_associations.forEach(association => {
                        if (association.quantity != '' && association.quantity != null) {
                            sum += parseFloat(association.quantity)
                        }
                    })
                }

                return sum;
            }
        },
        watch: {
            purchases: {
                handler() {
                    this.updateVentilationValidity();
                },
                deep: true
            }
        },
        methods : {
            updateVentilationValidity() {
                // Si les frais généraux sont autorisés, aucune contrainte
                if (parseInt(this.allowed_overheads, 10) !== 0) {
                    this.isVentilationValid = true;
                } else {
                    // Chaque ligne non vide SANS article_id avec une quantité > 0 doit être entièrement ventilée
                    const hasInvalid = this.purchases.some((purchase) => {
                        const qty = parseFloat(purchase.quantity) || 0;

                        // Lignes de stock (article_id présent) : pas de contrainte de ventilation
                        if (purchase.article_id) {
                            return false;
                        }

                        // Ligne "vide" (aucune info + aucune ventilation) : on l'ignore dans le contrôle
                        const hasAnyAssociation = (purchase.deal_associations && purchase.deal_associations.length) ||
                                                  (purchase.intervention_associations && purchase.intervention_associations.length);
                        const hasAnyContent = (purchase.reference && purchase.reference !== '') ||
                                              (purchase.designation && purchase.designation !== '') ||
                                              (parseFloat(purchase.amount) || 0) !== 0;

                        if (!hasAnyAssociation && !hasAnyContent) {
                            return false;
                        }

                        if (qty <= 0) {
                            return false;
                        }

                        let assoc = 0;
                        if (purchase.deal_associations && purchase.deal_associations.length) {
                            purchase.deal_associations.forEach((a) => {
                                if (a.quantity !== '' && a.quantity != null) {
                                    assoc += parseFloat(a.quantity);
                                }
                            });
                        }
                        if (purchase.intervention_associations && purchase.intervention_associations.length) {
                            purchase.intervention_associations.forEach((a) => {
                                if (a.quantity !== '' && a.quantity != null) {
                                    assoc += parseFloat(a.quantity);
                                }
                            });
                        }

                        // Il reste une partie en "frais généraux" => non valide
                        return assoc < qty;
                    });

                    this.isVentilationValid = !hasInvalid;
                }

                const btn = document.getElementById('save-expense-form');
                if (btn) {
                    btn.disabled = !this.isVentilationValid;
                }
            },
             addLotToDealAssociation(association, index) {
                const lot = association.lots.find(l => l.id === association.lot_id);
                if (!lot) {
                    association.lot_designation = null;
                    return;
                }
                association.lot_designation = `${lot.number} - ${lot.name}`;
                this.currentLotSelected = lot;
            },
            addRow: function (purchase) {
                var data = {
                    uniq: Math.random().toString(36).substr(2, 9),
                    id: null,
                    articel_id: null,
                    is_title: 0,
                    type: 1,
                    reference: '',
                    designation: '',
                    quantity: 1,
                    amount: 0,
                    discount: 0,
                    vat: this.isAutoliquidation == 0 ? this.globalTva  : 0,
                    total_ht: 0,
                    total_discount: 0,
                    total_after_discount: 0,
                    total_vat: 0,
                    total_ttc: 0,
                    deal_associations: [],
                    intervention_associations: []
                }

                if(this.associate_all_deal_purchases && this.selectedDealAssociation != null){
                    data.deal_associations = [{
                        'deal_id': this.selectedDealAssociation.id,
                        'deal_designation': this.selectedDealAssociation.designation,
                        'quantity': parseFloat(data.quantity),
                        'lot_id': null,
                        'lot_designation': null,
                        'lots': []
                    }]
                }

                if(this.associate_all_intervention_purchases && this.selectedInterventionAssociation != null){
                    data.intervention_associations = [{
                        'intervention_id': this.selectedInterventionAssociation.id,
                        'intervention_designation': this.selectedInterventionAssociation.designation,
                        'quantity': parseFloat(data.quantity)
                    }]
                }

                if (purchase != null) {
                    data.id = purchase.id
                    data.article_id = purchase.article_id
                    data.is_title = purchase.is_title
                    data.type = purchase.type
                    data.reference = purchase.reference
                    data.designation = purchase.designation
                    data.description = purchase.description
                    data.quantity = purchase.quantity
                    data.amount = purchase.amount
                    data.unit = purchase.unit
                    data.discount = purchase.discount
                    data.vat = purchase.vat
                    data.deal_associations = purchase.deal_associations
                    data.intervention_associations = purchase.intervention_associations
                }

                this.purchases.push(data)
            },
            resetVentilation(){
                if(!this.interventionVentilation)
                    this.purchases[this.selectedIndexAssociation].intervention_associations = []
                else 
                    this.purchases[this.selectedIndexAssociation].deal_associations = []   
            },
            deleteRow: function (index) {
                this.purchases.splice(index, 1)
                if (this.purchases.length == 0) {
                    this.addRow()
                }
            },
            checkIfNewRowNeeded: function (index) {
                if (this.purchases.length > 0) {
                    if (this.purchases.length - 1 == index) {
                        this.addRow()
                    }
                }
            },
            openAssociationsModal(index) {
                this.selectedIndexAssociation = index
                this.selectedDealAssociation = null;
                this.associate_all_deal_purchases = false;
                this.selectedInterventionAssociation = null;
                this.associate_all_intervention_purchases = false;
                if(this.purchases[index].deal_associations && this.purchases[index].deal_associations.length == 0 &&  this.purchases[index].intervention_associations && this.purchases[index].intervention_associations.length == 0 )
                    this.interventionVentilation = false;

                if(this.purchases[index].deal_associations && this.purchases[index].deal_associations.length > 0 &&  this.purchases[index].intervention_associations && this.purchases[index].intervention_associations.length == 0 )
                    this.interventionVentilation = false;


                if(this.purchases[index].deal_associations && this.purchases[index].deal_associations.length == 0 &&  this.purchases[index].intervention_associations && this.purchases[index].intervention_associations.length > 0 )
                    this.interventionVentilation = true;

                $('#associationsModal').modal({'backdrop': 'static'})
            },
            deleteAssociation(index) {
                if(!this.interventionVentilation)
                    this.purchases[this.selectedIndexAssociation].deal_associations.splice(index, 1)
                else
                    this.purchases[this.selectedIndexAssociation].intervention_associations.splice(index, 1)    
            },
            validAssociations() {
                this.selectedIndexAssociation = null;
                $('#associationsModal').modal('hide')
            },
            addOrUpdateAssociation(item) {
                var findedIndex = this.purchases[this.selectedIndexAssociation].deal_associations.findIndex(association => {
                    return association.deal_id == item.item.id
                })

                this.selectedDealAssociation = item.item;

               

                if (findedIndex >= 0) {
                    $('#association' + findedIndex).focus()
                } else {
                    this.purchases[this.selectedIndexAssociation].deal_associations.push({
                        'deal_id': item.item.id,
                        'deal_designation': item.item.designation,
                        'quantity': parseFloat(this.purchases[this.selectedIndexAssociation].quantity) - this.total_associations,
                        'lot_id': null,
                        'lot_designation': null,
                        'lots': item.item.lots && item.item.lots.length > 0 ? item.item.lots : []
                    })
                }
            },
            // Association des interventions
            addOrUpdateInterventionAssociation(item){
                var findedIndex = this.purchases[this.selectedIndexAssociation].intervention_associations.findIndex(association => {
                    return association.intervention_id == item.item.id
                });

                this.selectedInterventionAssociation = item.item;

                if (findedIndex >= 0) {
                    $('#association' + findedIndex).focus()
                } else {
                    this.purchases[this.selectedIndexAssociation].intervention_associations.push({
                        'intervention_id': item.item.id,
                        'intervention_designation': item.item.designation,
                        'quantity': parseFloat(this.purchases[this.selectedIndexAssociation].quantity) - this.total_associations,
                    })
                }
            },
            associateAllDealPurchases(){
                if(this.associate_all_deal_purchases){
                    this.purchases.forEach((purchase, index) => {
                        purchase.deal_associations = [{
                            'deal_id' : this.selectedDealAssociation.id,
                            'deal_designation' : this.selectedDealAssociation.designation,
                            'quantity' : parseFloat(purchase.quantity),
                            'lot_id' : this.currentLotSelected ? this.currentLotSelected.id : null,
                            'lot_designation' : this.currentLotSelected ? this.currentLotSelected.designation : null,
                            'lots' : this.selectedDealAssociation.lots,
                        }];
                        purchase.intervention_associations = [];
                    });

                }
            },
            associateAllDealLotPurchases(){
                if(this.associate_all_deal_lot_purchases){
                    this.purchases.forEach((purchase, index) => {
                        purchase.deal_associations = [{
                            'deal_id' : this.selectedDealAssociation.id,
                            'deal_designation' : this.selectedDealAssociation.designation,
                            'quantity' : parseFloat(purchase.quantity),
                            'lot_id' : this.currentLotSelected.id,
                            'lot_designation' : this.currentLotSelected.number + ' - ' + this.currentLotSelected.name,
                            'lots' : this.selectedDealAssociation.lots || [],
                        }];
                        purchase.intervention_associations = [];
                    });

                }
            },
            associateAllInterventionPurchases(){
                if(this.associate_all_intervention_purchases){
                    this.purchases.forEach((purchase, index) => {
                        purchase.intervention_associations = [{
                            'intervention_id' : this.selectedInterventionAssociation.id,
                            'intervention_designation' : this.selectedInterventionAssociation.designation,
                            'quantity' : parseFloat(purchase.quantity),
                        }];
                        purchase.deal_associations = [];
                    });

                }
            },
            getPurchases: async function (route) {
                this.loading = true;
                fetch(route, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    data.forEach(purchase => {
                        this.addRow(purchase)
                    })
                    this.addRow(null)
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
            }
        },
        mounted(){
            const self = this;
            this.isAutoliquidation = this.oldAutoliquidation;

            // Pour l'edition
            if($('#is_subcontractor').length > 0){
                let isSubcontractor = $('#is_subcontractor').val();
                self.isAutoliquidation = isSubcontractor;
            }

            if($('#type_area').length > 0){
                let area = $('#type_area').val();
                if(area == 2 || area == 3){
                    self.globalTva = 0;
                }
            }
          

            $('#company_id').on('change', function () {
                setTimeout(() => {
                    if($('#is_subcontractor').length > 0){
                        let isSubcontractor = $('#is_subcontractor').val();
                        self.isAutoliquidation = isSubcontractor;
                    }

                    if($('#type_area').length > 0){
                        let area = $('#type_area').val();
                        console.log(area);
                        // Type Intra-communautaire
                        if(area == 2 || area == 3){
                            self.globalTva = 0;
                            self.purchases.forEach((purchase,index) => {
                                purchase.vat = null;
                                self.$refs.purchaseFormComponent[index].globalTva = self.globalTva;
                                self.$refs.purchaseFormComponent[index].compute();
                            });
                        }  else {
                            self.globalTva = self.tvaGlobal;
                            self.purchases.forEach((purchase,index) => {
                                purchase.vat = null;
                                self.$refs.purchaseFormComponent[index].globalTva = self.globalTva;
                                self.$refs.purchaseFormComponent[index].compute();
                            });
                        }
                    }
                }, 1500);
            })
          
            this.discount = this.oldDiscount

            const jsonPurchaseBackup = JSON.parse(this.oldPurchases)
            if (Array.isArray(jsonPurchaseBackup)) {
                if (jsonPurchaseBackup.length == 0) {
                    this.addRow(null)
                } else {
                    jsonPurchaseBackup.forEach(purchase => {
                        this.addRow(purchase)
                    })
                }
                this.loading = false
            } else {
                this.getPurchases(jsonPurchaseBackup)
            }

            // Creation autocomplete
            $("#dealsAutocomplete").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.dealsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: {q: request.term},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if (!item.item) {
                        $(e.target).val("")
                        this.searchDeal = null;
                    }
                },
                select: (e, item) => {
                    this.addOrUpdateAssociation(item)

                    $(e.target).val("")
                    this.searchDeal = null
                }
            }).focus(() => {
                $("#dealsAutocomplete").autocomplete("search", '');
            });

             $("#interventionsAutocomplete").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.interventionsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: {q: request.term},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if (!item.item) {
                        $(e.target).val("")
                        this.searchIntervention = null
                    }
                },
                select: (e, item) => {
                    this.addOrUpdateInterventionAssociation(item)

                    $(e.target).val("")
                    this.searchIntervention = null
                }
            }).focus(() => {
                $("#interventionsAutocomplete").autocomplete("search", '');
            });

            console.log('allowed_overheads', this.allowed_overheads);
        }
    }
</script>
